import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Svg,
  Path,
} from "@react-pdf/renderer";
import moment from "moment";
import Logo from "../../assets/images/logo-full.svg";
import config from "../../config";
import { useParams } from "react-router-dom";
import PrintFooter from "../../Pdf/PrintFooter";
import pdfStyles from "../../Pdf/pdfStyles";
import { NumberFormat } from "../../components/Shared/Utility";
import dayjs from "dayjs";

function SubscriptionInvoicePdf(props) {
  const params = useParams();
  const [AccessKey, setAccessKey] = useState(
    localStorage.getItem("AdminAccessKey")
  );
  const [PumpDetail, setPumpDetail] = useState({});

  const [UserID, setUserID] = useState(localStorage.getItem("AdminID"));
  const [loading, setLoading] = useState(false);
  const [listofLedger, SetlistofLedger] = useState([]);
  const [closingBalance, setClosingBalance] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const [totalDebit, settotalDebit] = useState("");
  const [totalCredit, settotalCredit] = useState("");
  const [cashBalance, setcashBalance] = useState("");
  const [purchasedInfo, setPurchasedInfo] = useState({});

  const [PumpID, setPumpID] = useState(0);

  const [openingBalance, setOpeningBalance] = useState("");

  const urlParams = new URLSearchParams(window.location.search);
  const StartDate = urlParams.get("StartDate");
  const EndDate = urlParams.get("EndDate");
  const Full_Name = urlParams.get("Full_Name");
  const [AllData, setAllData] = useState("");

  useEffect(() => {
    document.title = "Invoice";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      PumpID: params.id,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetPackagePurchaseByPumpID",
      header: {
        "Content-Type": "application/josn",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          SetlistofLedger(response.data.listofRecords);
          setTotalRecords(response.data.totalRecords);

          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {});
  }, [params]);

  useEffect(() => {
    document.title = "Invoice";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: params.id,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetPackagePurchaseByID",
      header: {
        "Content-Type": "application/josn",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setPurchasedInfo(response.data.PackagePurchased);
          setPumpID(response.data.PackagePurchased.PumpID);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {});
  }, [params]);

  console.log(PumpID)

  useEffect(() => {
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: PumpID,
    };

    console.log(data)

    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetPetrolPumpInfo",
      header: {
        "Content-Type": "application/josn",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setPumpDetail(response.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {});
  }, [params,PumpID]);

  // Create styles
  const styles = StyleSheet.create({
    box: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "200px",
      padding: "0px 20px",
    },

    boxleft: {
      width: "40%",
      marginTop: "50px",
    },
    boxright: {
      width: "50%",
    },
    invoicecontent: {},
    ul: {
      padding: "0",
    },
    li: {
      flexDirection: "row",
      justifyContent: "space-between",
      paddingHorizontal: 0,
      paddingVertical: 2,
      gap: "5",
    },
    linew: {
      display: "flex",
      alignItems: "center",
      paddingVertical: 2,
      justifyContent: "space-between",
    },
    label: {
      width: "25%",
      fontSize: 10,
      fontWeight: "extralight",
      color: "#000",
      textAlign: "right",
    },
    boxlabel: {
      fontSize: 15,
      fontWeight: "extralight",
      color: "#000",
    },
    span: {
      width: "80%",
      fontSize: 10,
      fontWeight: "bold",
      color: "#000",
      textAlign: "left",
    },
    info: {
      fontSize: 16,
      textAlign: "left",
      padding: "0px 20px",
      margin: "20px 0px 10px 0px",
      textAlign: "left",
      fontSize: "16px",
      fontWeight: "bold",
    },
  });

  const generateData = () => {
    return (
      <View style={pdfStyles.row}>
        <View
          style={[
            pdfStyles.td,
            {
              width: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          ]}
        >
          <Text style={pdfStyles.tdValue}>1</Text>
        </View>
        <View
          style={[
            pdfStyles.td,
            {
              width: 420,
              height: 100,
              display: "flex",
              justifyContent: "center",
            },
          ]}
        >
          <Text style={pdfStyles.tdValue}>
            {purchasedInfo.PackageName} Package{" "}
          </Text>
          <Text style={[pdfStyles.tdValue, { marginVertical: 5 }]}>
            form {moment(purchasedInfo.StartDate).format("DD MMMM YYYY")} to{" "}
            {moment(purchasedInfo.EndDate).format("DD MMMM YYYY")}{" "}
          </Text>
          <Text style={pdfStyles.tdValue}>
            Payment Received via {purchasedInfo.PaymentMode}.
          </Text>
        </View>
        <View
          style={[
            pdfStyles.td,
            {
              width: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          ]}
        >
          <Text style={pdfStyles.tdValue}>
            {NumberFormat(purchasedInfo.PackagePrice)}
          </Text>
        </View>
      </View>
    );
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={pdfStyles.page} orientation="portrait">
        <View style={pdfStyles.section}>
          <View style={[styles.box]}>
            <View style={[styles.boxleft, { marginTop: "-10px" }]}>
              <Svg
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="34"
                viewBox="0 0 200 34"
                fill="none"
              >
                <Path
                  d="M25.4034 9.03717C23.405 5.82907 19.8457 3.69395 15.7878 3.69395C9.53565 3.69395 4.4673 8.7623 4.4673 15.0144C4.4673 16.2563 4.66729 17.4515 5.03681 18.5696C4.34059 17.1073 3.95093 15.4708 3.95093 13.7434C3.95093 7.5351 8.98371 2.50232 15.192 2.50232C19.7199 2.50232 23.6225 5.17943 25.4034 9.03717Z"
                  fill="#061956"
                />
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.1987 14.5775C15.2079 14.5775 16.0259 13.7595 16.0259 12.7504C16.0259 11.7413 15.2079 10.9232 14.1987 10.9232C13.1896 10.9232 12.3716 11.7413 12.3716 12.7504C12.3716 13.7595 13.1896 14.5775 14.1987 14.5775ZM14.1987 13.7434C14.7472 13.7434 15.1918 13.2988 15.1918 12.7504C15.1918 12.2019 14.7472 11.7574 14.1987 11.7574C13.6503 11.7574 13.2057 12.2019 13.2057 12.7504C13.2057 13.2988 13.6503 13.7434 14.1987 13.7434Z"
                  fill="#061956"
                />
                <Path
                  d="M14.6337 11.2683L16.0206 12.6562L16.4224 4.4243L12.6367 11.8122L14.6337 11.2683Z"
                  fill="#061956"
                />
                <Path
                  d="M27.0698 0.101685L25.8782 7.2316C24.5277 5.27865 20.357 1.37276 14.4783 1.37276C14.4783 1.37276 9.77136 1.37276 5.93828 5.20583C2.54204 8.60207 1.17177 16.705 4.58777 20.8559C4.82477 20.564 5.0806 20.2414 5.3533 19.8974L5.35349 19.8972C7.25173 17.5032 9.96676 14.0791 12.8299 12.8323V13.9246C11.5028 15.0489 11.4073 15.164 10.3845 16.3971C10.3052 16.4927 10.2203 16.595 10.1288 16.705C7.42437 19.9589 7.11817 22.9479 6.83201 26.9133V30.4088H0L1.39023 13.9246C1.39023 13.9246 1.39023 8.09553 5.20345 4.28232C9.01666 0.469104 14.4783 0.101685 14.4783 0.101685H27.0698Z"
                  fill="#061956"
                />
                <Path
                  d="M10.5062 17.6981C10.8081 17.0308 12.1811 15.5267 12.8299 14.858C15.052 15.8256 16.6136 14.494 16.5102 12.6647C16.5098 12.6577 16.5094 12.6506 16.5091 12.6436L16.6075 10.6277H25.5373C25.5373 10.6277 25.1679 13.3526 24.723 15.2751C24.2781 17.1976 22.4192 17.6915 21.5453 17.6981H10.5062Z"
                  fill="#061956"
                />
                <Path
                  d="M10.1288 18.5322C9.61387 19.2792 8.77703 20.8158 8.43172 22.4149C8.26921 23.4576 8.38112 25.1855 10.1288 25.1855C11.9298 25.1855 12.6726 22.8242 11.7773 21.6106C10.8835 20.3991 10.2348 19.2108 10.1288 18.5322Z"
                  fill="#061956"
                />
                <Path
                  d="M38.9491 0.786876H51.1632V4.45605H43.3077V7.68198H49.0455V11.1049H43.3077V18H38.9491V0.786876ZM60.0997 18.3694C57.5059 18.3694 55.5523 17.6799 54.2389 16.3009C52.9256 14.9054 52.2689 13.0667 52.2689 10.7848V0.786876H56.6276V10.834C56.6276 11.9832 56.9313 12.8533 57.5387 13.4443C58.1625 14.0353 59.0162 14.3308 60.0997 14.3308C61.1833 14.3308 62.0287 14.0353 62.6362 13.4443C63.2436 12.8533 63.5473 11.9832 63.5473 10.834V0.786876H67.906V10.7848C67.906 13.0831 67.2493 14.9218 65.9359 16.3009C64.639 17.6799 62.6936 18.3694 60.0997 18.3694ZM69.9953 0.786876H82.2095V4.45605H74.354V7.68198H80.0917V11.1049H74.354V14.3308H82.2095V18H69.9953V0.786876ZM83.9432 0.786876H88.3019V14.3308H95.788V18H83.9432V0.786876ZM97.6411 0.786876H105.275C106.769 0.786876 107.91 1.18088 108.698 1.96889C109.486 2.74049 109.88 3.88146 109.88 5.39182C109.88 6.27833 109.675 7.04992 109.264 7.7066C108.854 8.34686 108.312 8.82295 107.639 9.13487C109.527 9.62738 110.471 10.9818 110.471 13.1981C110.471 14.1667 110.257 15.0203 109.831 15.7591C109.42 16.4814 108.846 17.0396 108.107 17.4336C107.385 17.8112 106.58 18 105.694 18H97.6411V0.786876ZM105.127 8.37149C106.047 8.37149 106.744 8.12523 107.22 7.63272C107.713 7.1238 107.959 6.39325 107.959 5.44107C107.959 4.35755 107.721 3.58596 107.245 3.12628C106.769 2.6502 105.997 2.41215 104.93 2.41215H99.5619V8.37149H105.127ZM105.275 16.3747C106.358 16.3747 107.171 16.1285 107.713 15.636C108.271 15.1435 108.55 14.3144 108.55 13.1488C108.55 12.016 108.263 11.2116 107.688 10.7355C107.114 10.243 106.219 9.99676 105.004 9.99676H99.5619V16.3747H105.275ZM121.312 18.3694C119.621 18.3694 118.086 18 116.707 17.2612C115.344 16.5061 114.269 15.4472 113.481 14.0846C112.693 12.722 112.299 11.1624 112.299 9.40575C112.299 7.64914 112.693 6.08954 113.481 4.72693C114.269 3.36433 115.344 2.30544 116.707 1.55026C118.069 0.795084 119.604 0.417496 121.312 0.417496C123.019 0.417496 124.554 0.795084 125.917 1.55026C127.279 2.30544 128.355 3.36433 129.143 4.72693C129.931 6.08954 130.325 7.64914 130.325 9.40575C130.325 11.1624 129.931 12.722 129.143 14.0846C128.355 15.4472 127.271 16.5061 125.892 17.2612C124.53 18 123.003 18.3694 121.312 18.3694ZM121.312 16.6456C122.625 16.6456 123.824 16.3501 124.907 15.7591C125.991 15.1681 126.844 14.3308 127.468 13.2473C128.092 12.1474 128.404 10.8669 128.404 9.40575C128.404 7.96106 128.092 6.69696 127.468 5.61345C126.861 4.51351 126.015 3.66804 124.932 3.07703C123.865 2.46961 122.674 2.1659 121.361 2.1659C120.031 2.1659 118.825 2.4614 117.741 3.05241C116.658 3.64342 115.796 4.48889 115.155 5.58882C114.532 6.68875 114.22 7.96106 114.22 9.40575C114.22 10.8669 114.532 12.1474 115.155 13.2473C115.779 14.3308 116.633 15.1681 117.717 15.7591C118.8 16.3501 119.998 16.6456 121.312 16.6456ZM141.681 18.3694C139.99 18.3694 138.455 18 137.076 17.2612C135.713 16.5061 134.638 15.4472 133.85 14.0846C133.062 12.722 132.668 11.1624 132.668 9.40575C132.668 7.64914 133.062 6.08954 133.85 4.72693C134.638 3.36433 135.713 2.30544 137.076 1.55026C138.438 0.795084 139.973 0.417496 141.681 0.417496C143.388 0.417496 144.923 0.795084 146.286 1.55026C147.648 2.30544 148.724 3.36433 149.512 4.72693C150.3 6.08954 150.694 7.64914 150.694 9.40575C150.694 11.1624 150.3 12.722 149.512 14.0846C148.724 15.4472 147.64 16.5061 146.261 17.2612C144.898 18 143.372 18.3694 141.681 18.3694ZM141.681 16.6456C142.994 16.6456 144.192 16.3501 145.276 15.7591C146.359 15.1681 147.213 14.3308 147.837 13.2473C148.461 12.1474 148.773 10.8669 148.773 9.40575C148.773 7.96106 148.461 6.69696 147.837 5.61345C147.23 4.51351 146.384 3.66804 145.301 3.07703C144.233 2.46961 143.043 2.1659 141.73 2.1659C140.4 2.1659 139.193 2.4614 138.11 3.05241C137.026 3.64342 136.165 4.48889 135.524 5.58882C134.9 6.68875 134.589 7.96106 134.589 9.40575C134.589 10.8669 134.9 12.1474 135.524 13.2473C136.148 14.3308 137.002 15.1681 138.085 15.7591C139.169 16.3501 140.367 16.6456 141.681 16.6456ZM153.649 0.786876H155.57V18H153.649V0.786876ZM156.383 9.258L164.435 0.786876H166.799L158.747 9.258L167.316 18H164.952L156.383 9.258Z"
                  fill="#061956"
                />
                <Path
                  d="M38.2235 24.3138H39.3686L41.5295 29.0418L43.6903 24.3138H44.8354V30.7687H43.7273V26.5762L41.8065 30.7687H41.2524L39.3316 26.5762V30.7687H38.2235V24.3138ZM49.864 24.3138H50.9999L53.5763 30.7687H52.3851L51.794 29.2819H49.0606L48.4789 30.7687H47.2784L49.864 24.3138ZM51.4708 28.3123L50.4273 25.5696L49.3838 28.3123H51.4708ZM56.2517 24.3138H57.3599L60.3795 28.811V24.3138H61.5523V30.7687H60.4442L57.4245 26.2622V30.7687H56.2517V24.3138ZM66.8191 24.3138H67.9549L70.5314 30.7687H69.3401L68.7491 29.2819H66.0157L65.4339 30.7687H64.2334L66.8191 24.3138ZM68.4259 28.3123L67.3824 25.5696L66.3389 28.3123H68.4259ZM75.9708 30.9072C75.2936 30.9072 74.6933 30.7718 74.1701 30.5009C73.6468 30.2238 73.2405 29.8329 72.9511 29.3281C72.6618 28.8171 72.5171 28.223 72.5171 27.5458C72.5171 26.8686 72.6618 26.2776 72.9511 25.7728C73.2405 25.2618 73.6468 24.8678 74.1701 24.5908C74.6933 24.3138 75.2936 24.1752 75.9708 24.1752C76.4325 24.1752 76.845 24.2245 77.2082 24.323C77.5714 24.4215 77.9008 24.5785 78.1963 24.7939V25.9113C77.9254 25.6774 77.6145 25.5081 77.2636 25.4034C76.9127 25.2988 76.5156 25.2464 76.0724 25.2464C75.6291 25.2464 75.2259 25.3419 74.8626 25.5327C74.5056 25.7174 74.2224 25.9852 74.0131 26.3361C73.8038 26.6809 73.6991 27.0841 73.6991 27.5458C73.6991 28.0137 73.7976 28.4231 73.9946 28.774C74.1916 29.1188 74.4656 29.3866 74.8165 29.5774C75.1674 29.7621 75.5675 29.8545 76.017 29.8545C76.491 29.8545 76.8819 29.7744 77.1897 29.6144V28.1645H76.1001V27.2319H78.3625V30.2423C77.79 30.6856 76.9927 30.9072 75.9708 30.9072ZM81.0395 24.3138H85.4074V25.2834H82.2123V27.0564H84.5856V28.026H82.2123V29.7991H85.4074V30.7687H81.0395V24.3138ZM93.0797 24.3138H97.4477V25.2834H94.2525V27.0564H96.6258V28.026H94.2525V29.7991H97.4477V30.7687H93.0797V24.3138ZM99.8079 24.3138H101.055L102.957 29.1988L104.868 24.3138H106.106L103.529 30.7687H102.394L99.8079 24.3138ZM108.781 24.3138H113.149V25.2834H109.954V27.0564H112.327V28.026H109.954V29.7991H113.149V30.7687H108.781V24.3138ZM115.739 24.3138H118.436C119.15 24.3138 119.701 24.4892 120.089 24.8401C120.477 25.191 120.671 25.6989 120.671 26.3638C120.671 26.8379 120.554 27.2411 120.32 27.5735C120.086 27.906 119.753 28.143 119.322 28.2846L120.634 30.7687H119.433L118.186 28.4046H116.912V30.7687H115.739V24.3138ZM118.223 27.435C118.605 27.435 118.913 27.3458 119.147 27.1672C119.381 26.9887 119.498 26.7209 119.498 26.3638C119.498 25.6435 119.073 25.2834 118.223 25.2834H116.912V27.435H118.223ZM124.903 28.3123L122.558 24.3138H123.804L125.467 27.1857L127.175 24.3138H128.412L126.021 28.3123V30.7687H124.903V28.3123ZM136.171 24.3138H138.332C139.034 24.3138 139.644 24.443 140.161 24.7016C140.678 24.9602 141.075 25.3296 141.352 25.8097C141.629 26.2899 141.767 26.8563 141.767 27.5089C141.767 28.5801 141.457 29.3927 140.835 29.9468C140.213 30.4947 139.345 30.7687 138.231 30.7687H136.171V24.3138ZM138.249 29.7991C139 29.7991 139.576 29.599 139.976 29.1988C140.382 28.7925 140.585 28.2292 140.585 27.5089C140.585 27.0718 140.496 26.687 140.318 26.3546C140.139 26.016 139.884 25.7543 139.551 25.5696C139.219 25.3788 138.825 25.2834 138.369 25.2834H137.344V29.7991H138.249ZM144.446 24.3138H147.142C147.857 24.3138 148.408 24.4892 148.795 24.8401C149.183 25.191 149.377 25.6989 149.377 26.3638C149.377 26.8379 149.26 27.2411 149.026 27.5735C148.792 27.906 148.46 28.143 148.029 28.2846L149.34 30.7687H148.14L146.893 28.4046H145.619V30.7687H144.446V24.3138ZM146.93 27.435C147.312 27.435 147.62 27.3458 147.854 27.1672C148.087 26.9887 148.204 26.7209 148.204 26.3638C148.204 25.6435 147.78 25.2834 146.93 25.2834H145.619V27.435H146.93ZM155.159 30.9072C154.513 30.9072 153.928 30.7687 153.405 30.4916C152.888 30.2084 152.478 29.8114 152.177 29.3004C151.881 28.7894 151.733 28.2046 151.733 27.5458C151.733 26.8871 151.881 26.3023 152.177 25.7913C152.478 25.2803 152.888 24.8832 153.405 24.6C153.928 24.3168 154.513 24.1752 155.159 24.1752C155.8 24.1752 156.378 24.3168 156.895 24.6C157.419 24.8832 157.828 25.2803 158.124 25.7913C158.425 26.3023 158.576 26.8871 158.576 27.5458C158.576 28.2046 158.425 28.7894 158.124 29.3004C157.828 29.8052 157.419 30.1992 156.895 30.4824C156.378 30.7656 155.8 30.9072 155.159 30.9072ZM155.159 29.8452C155.572 29.8452 155.947 29.7529 156.286 29.5682C156.625 29.3773 156.892 29.1095 157.089 28.7648C157.292 28.4139 157.394 28.0076 157.394 27.5458C157.394 27.0903 157.296 26.6901 157.099 26.3453C156.902 25.9944 156.634 25.7236 156.295 25.5327C155.957 25.3419 155.578 25.2464 155.159 25.2464C154.741 25.2464 154.359 25.3419 154.014 25.5327C153.676 25.7236 153.408 25.9944 153.211 26.3453C153.014 26.6901 152.915 27.0903 152.915 27.5458C152.915 28.0076 153.014 28.4139 153.211 28.7648C153.414 29.1095 153.685 29.3773 154.023 29.5682C154.368 29.7529 154.747 29.8452 155.159 29.8452ZM161.257 24.3138H163.842C164.55 24.3138 165.117 24.5015 165.542 24.8771C165.973 25.2526 166.188 25.7667 166.188 26.4192C166.188 27.0964 165.976 27.6136 165.551 27.9706C165.126 28.3215 164.553 28.497 163.833 28.497H162.43V30.7687H161.257V24.3138ZM163.695 27.5274C164.575 27.5274 165.015 27.158 165.015 26.4192C165.015 25.662 164.575 25.2834 163.695 25.2834H162.43V27.5274H163.695Z"
                  fill="#061956"
                />
                <Path
                  d="M153.19 30.9245C153.603 29.1493 154.605 27.4434 155.222 26.6143C155.349 27.3675 156.126 28.6867 157.196 30.0316C158.268 31.3788 157.379 34 155.222 34C153.129 34 152.995 32.0819 153.19 30.9245Z"
                  fill="#061956"
                />
              </Svg>
            </View>
            <View style={styles.boxright}>
              <View style={[styles.invoicecontent, { border: "none" }]}>
                <View style={styles.ul}>
                  <View style={styles.li}>
                    <Text
                      style={[styles.span, { textAlign: "left", fontSize: 12 }]}
                    >
                      Dated {"        "}
                      {dayjs().format("ddd DD MMM YYYY")}
                    </Text>
                  </View>
                  <View style={styles.li}>
                    <Text
                      style={[styles.span, { textAlign: "left", fontSize: 12 }]}
                    >
                      Invoice # {"   "}
                      {purchasedInfo.ID}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={[styles.info, { paddingLeft: "20px" }]}>
            <Text>Subscription Invoice</Text>
          </View>
          <View style={[styles.box, { marginTop: "10px" }]}>
            <View style={styles.boxright}>
              <View style={styles.invoicecontent}>
                <View style={styles.ul}>
                  <View style={styles.li}>
                    <Text style={[styles.span, { fontSize: 14 }]}>
                      Bill To:
                    </Text>
                  </View>
                  <View style={styles.li}>
                    <Text style={[styles.span, { fontSize: 12 }]}>
                      {PumpDetail.PumpDetails?.Name} (
                      {PumpDetail.PumpDetails?.PumpCode})
                    </Text>
                  </View>
                  <View style={styles.li}>
                    <Text style={[styles.span, { color: "grey" }]}>
                      {PumpDetail.PumpDetails?.Mobile}
                    </Text>
                  </View>
                  <View style={styles.li}>
                    <Text style={[styles.span, { color: "grey" }]}>
                      {PumpDetail.PumpDetails?.Email}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>

        <View style={pdfStyles.section}>
          <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>SR.</Text>
              </View>
              <View style={[pdfStyles.th, { width: 420 }]}>
                <Text style={pdfStyles.thValue}>Description</Text>
              </View>
              <View style={[pdfStyles.th, { width: 100, textAlign: "center" }]}>
                <Text style={pdfStyles.thValue}>Price</Text>
              </View>
            </View>
            {generateData()}
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 470, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Discount</Text>
              </View>
              <View style={[pdfStyles.th, { width: 100, textAlign: "center" }]}>
                <Text style={pdfStyles.thValue}>
                  {NumberFormat(purchasedInfo.DiscountValue)}
                </Text>
              </View>
            </View>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 470, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Received</Text>
              </View>
              <View style={[pdfStyles.th, { width: 100, textAlign: "center" }]}>
                <Text style={pdfStyles.thValue}>
                  {NumberFormat(purchasedInfo.NetReceiveable)}
                </Text>
              </View>
            </View>
          </View>

          <View style={{ marginTop: 10 }}>
            <Text style={pdfStyles.thValue}>
              This invoice serves as proof of your subscription purchase. Please
              retain it for your records. If you have any questions or require
              assistance, feel free to contact our support team at
              info@fuelbook.pk.
            </Text>
          </View>

          <View style={{ marginTop: 350 }}>
            <Text style={pdfStyles.thValue}>
              Address: Fast Mall, Railway Road Kasur, Pakistan
            </Text>
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <>
      <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
        {loading ? (
          "Loading..."
        ) : (
          <PDFViewer
            width="100%"
            height="100%"
            fileName="Subscription Invoice.pdf"
          >
            <MyDocument />
          </PDFViewer>
        )}
      </div>
    </>
  );
}

export default SubscriptionInvoicePdf;
